<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "App",
  components: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="less">
.header {
  position: absolute;
  height: 2rem;
  border: 1px solid red;
}
.navbar-wrapper {
  width: 295px;
  height: 100%;
  background: #262626;
  color: #fff;
}

.page1 {
  height: 100%;
  background: url(../../assets/home/mobile/first_bg01.png);
  background-size: 100% 100%;
}
</style>
